<template>
    <div class="wizard-page" v-if="!showApplicationOverview">
        <Toast position="top-center" />
        <div v-if="loading" class="page-content-skeleton" aria-busy="true">
            <div class="card wizard-steps-skeleton mb-3">
                <div class="card-header">
                    <Skeleton
                        height="2rem"
                        width="10rem"
                        class="mb-2"
                    ></Skeleton>
                </div>
                <div class="card-body row">
                    <div class="col-4">
                        <Skeleton width="100%" height="4rem"></Skeleton>
                    </div>
                    <div class="col-4">
                        <Skeleton width="100%" height="4rem"></Skeleton>
                    </div>
                    <div class="col-4">
                        <Skeleton width="100%" height="4rem"></Skeleton>
                    </div>
                </div>
            </div>
            <div class="card wizard-card-skeleton version-1 mb-3">
                <div class="card-body">
                    <div class="card-heading">
                        <Skeleton
                            height="2rem"
                            width="10rem"
                            class="mb-2"
                        ></Skeleton>
                    </div>
                    <hr />
                    <div class="row mb-4">
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-4">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card wizard-card-skeleton version-2 mb-3">
                <div class="card-body">
                    <div class="card-heading">
                        <Skeleton
                            height="2rem"
                            width="10rem"
                            class="mb-2"
                        ></Skeleton>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-3">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-3">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-3">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-3">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card wizard-card-skeleton version-3 mb-3">
                <div class="card-body">
                    <div class="card-heading">
                        <Skeleton
                            height="2rem"
                            width="10rem"
                            class="mb-2"
                        ></Skeleton>
                    </div>
                    <hr />
                    <div class="row mb-4">
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                        <div class="col-2">
                            <Skeleton
                                height="1.5rem"
                                width="7rem"
                                class="mb-2"
                            ></Skeleton>
                            <Skeleton width="100%" height="3rem"></Skeleton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content" aria-busy="false">
            <div
                v-if="wizardStructure && wizardStructure.steps && !loading"
                class="card wizard-steps-card mb-3"
            >
                <div class="card-header d-flex justify-content-between">
                    <div class="summary d-flex flex-wrap">
                        <h4 class="job-title my-1 me-3">
                            {{ wizardData.applicationCycle.name }} <span> - {{ $t(wizardStructure.titleKey) }}</span>
                            <span v-if="wizardData.applicationType === 'TRAINEE'">
                                {{
                                    $t('lib_register_before', [
                                        formatDate(wizardData.registrationEndDate),
                                    ])
                                }}
                            </span>
                        </h4>
                        <div
                            class="job-status py-1 text-uppercase fw-bold"
                            :class="wizardData.status"
                        >
                            <font-awesome-icon class="job-status-icon me-2 fs-4" :icon="applicationStatusIcon(wizardData.status)" :class="wizardData.status"
                            />
                            <span
                                class="job-status-text"
                                :class="wizardData.status"
                            >
                                {{ $t(`st_${wizardData.status.toLowerCase()}`) }}
                            </span>
                        </div>
                    </div>                  
                    <div class="actions d-flex flex-wrap align-items-right gap-3">
                        <!-- save as draft button -->
                        <button
                            v-if="wizardData?.status === 'DRAFT'"
                            type="button"
                            class="btn btn-primary ms-auto px-3"
                            @click="redirectToDashboard()"
                        >
                            {{ $t('btn_save_as_draft') }}
                        </button> 
                        <!-- review application button -->
                        <button
                            v-if="wizardData.status === 'DRAFT'"
                            type="button"
                            class="btn btn-success ms-auto px-3"
                            :disabled="!canApply || appLoading"
                            @click="toggleApplicationOverview()"
                        >
                            {{ $t('btn_review_application') }}
                        </button>
                        <!-- save button -->
                        <button
                            v-if="
                                wizardData?.status !== 'DRAFT'
                            "
                            type="button"
                            class="btn btn-success ms-auto px-3"
                            :disabled="!canApply || appLoading"
                            @click="submitWizard()"
                        >
                            {{ $t('btn_save') }}
                        </button>
                    </div>                   
                </div>
                <div class="card-body">
                    <div class="wizard-steps fw-bold" :data-step-count="wizardStructure.steps.length">
                        <div
                            class="step col p-3"
                            :class="{
                                active: index === activeTab,
                                'text-danger': step.hasError,
                            }"
                            v-for="(step, index) in wizardStructure.steps"
                            :key="step.stepNumber"
                            role="button"
                            :data-step="index + 1"
                            @click="changeTab(index)"
                            :aria-label="$t(step.translationKey)"
                        >       
                            <span v-if="step.isCompleted">
                                <font-awesome-icon
                                    class="me-2 text-success"
                                    icon="fal fa-check-circle"
                                />
                            </span>
                            <span v-else>
                                <font-awesome-icon :icon="stepIcon(step)" class="me-2"/>
                            </span>
                            {{ $t(step.translationKey) }}
                        </div>
                    </div>
                </div>
            </div>
            <TabView
                v-if="wizardStructure && wizardStructure.steps && !loading"
                :activeIndex="activeTab"
            >
                <TabPanel
                    v-for="step in wizardStructure.steps"
                    :key="step.stepNumber"
                >
                    <template #header>
                        <font-awesome-icon class="fas fa-calendar"/>
                        <span
                            :class="{
                                'text-success': step.isValid,
                                'text-danger': step.hasError,
                            }"
                            >{{ $t(step.translationKey) }}</span
                        >
                    </template>
                    <div v-for="block in step.blocks" :key="block.id">
                        <component
                            @check-error-for-other-blocks="
                                focusOnNearestBlockError
                            "
                            :is="block.name"
                            :block="block"
                            :application-id="applicationId"
                            :application-type="applicationType"
                        ></component>
                    </div>
                </TabPanel>
            </TabView>
            <div class="wizard-actions d-flex gap-3 mb-5">
                <!-- previous tab arrow -->
                <button
                    v-if="activeTab"
                    type="button"
                    class="btn btn-link p-0 fs-1 lh-1"
                    :disabled="appLoading"
                    @click="changeTab(activeTab - 1)"
                    aria-label="Previous tab"
                >
                    <font-awesome-icon icon="fad fa-arrow-circle-left"/>

                </button>
                <!-- next tab arrow -->
                <button
                    v-if="activeTab !== wizardStructure?.numberOfSteps - 1"
                    type="button"
                    class="btn btn-link ms-auto p-0 fs-1 lh-1"
                    :disabled="appLoading"
                    @click="changeTab(activeTab + 1)"
                    aria-label="Next tab"
                >
                    <font-awesome-icon icon="fad fa-arrow-circle-right" :focusable="true"/>
                </button>  
                <!-- save as draft button -->
                <button
                    v-if="
                        activeTab === wizardStructure?.numberOfSteps - 1 &&
                        wizardData.status === 'DRAFT'
                    "
                    type="button"
                    class="btn btn-primary ms-auto px-3"
                    @click="redirectToDashboard()"
                >
                    {{ $t('btn_save_as_draft') }}
                </button> 
                <!-- review application button -->
                <button
                    v-if="
                        activeTab === wizardStructure?.numberOfSteps - 1 &&
                        wizardData.status === 'DRAFT'
                    "
                    type="button"
                    class="btn btn-success px-3"
                    :disabled="!canApply || appLoading"
                    @click="toggleApplicationOverview()"
                >
                    {{ $t('btn_review_application') }}
                </button>          
                <!-- save button -->
                <button
                    v-if="
                        activeTab === wizardStructure?.numberOfSteps - 1 &&
                        wizardData?.status !== 'DRAFT'
                    "
                    type="button"
                    class="btn btn-success ms-auto px-3"
                    :disabled="!canApply || appLoading"
                    @click="submitWizard()"
                >
                    {{ $t('btn_save') }}
                </button>
            </div>
        </div>
    </div>
    <ConfirmPopup></ConfirmPopup>
    <div class="application-overview" v-if="showApplicationOverview">
        <ApplicationOverview>
            <div class="d-flex justify-content-end gap-3 mb-5">
                <button
                    type="button"
                    class="btn btn-primary px-3"
                    :disabled="!canApply || appLoading"
                    @click="toggleApplicationOverview()"
                >
                    {{ $t('btn_edit') }}
                </button>
                <button
                    v-if=" wizardData?.status === 'DRAFT'"
                    type="button"
                    class="btn btn-success px-3"
                    :disabled="!canApply || appLoading"
                    @click="toggleConfirmDialog(true)"
                >
                    {{ $t('btn_submit') }}
                </button>
            </div>
        </ApplicationOverview>
        
    </div>
    <Dialog
        :modal="true"
        :dismissableMask="true"
        v-model:visible="showConfirmDialog"
        :showHeader="false"
    >
        <h2
            class="dialog-title mb-3 text-center"
            :class="isCORSite ? 'text-cor-green' : 'text-eesc-blue-400'"
        >
            <font-awesome-icon icon="fas fa-exclamation-triangle"/>
            {{ $t('lib_on_submit') }}
        </h2>

        <div class="d-flex mt-5 mb-3">
            <Checkbox binary v-model="firstCheckbox" inputId="trueInfo" name="trueInfo" value="trueInfo" />
            <label @click="toggleCheckbox('firstCheckbox')" for="trueInfo" class="mx-2 pointer"> {{ $t('cand_confirmation') }} </label>
        </div>

        <div class="d-flex mb-5">
            <Checkbox binary v-model="secondCheckbox" inputId="processedInfo" name="processedInfo" value="processedInfo" />
            <label @click="toggleCheckbox('secondCheckbox')" for="processedInfo" class="mx-2 pointer"> {{ $t(`final_2_${currentSite}`) }} </label>
        </div>

        <div class="mt-4 d-flex justify-content-between">
            <button
                type="button"
                :disabled="(!firstCheckbox || !secondCheckbox) || !canApply || appLoading"
                @click="submitWizard()"
                class="confirm-submit-application-btn btn btn-lg btn-success px-5 py-1 me-2"
            >
                {{ $t('btn_confirm') }}
            </button>
            <button
                type="button"
                @click="toggleConfirmDialog(false)"
                class="cancel-submit-application-btn btn btn-lg btn-outline-secondary px-5 py-1"
            >
                {{ $t('btn_cancel') }}
            </button>
        </div>
    </Dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { defineComponent } from 'vue';

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import Skeleton from 'primevue/skeleton';
import ConfirmPopup from 'primevue/confirmpopup';
import Checkbox from 'primevue/checkbox'

// Blocks : START
import Interest from '@/components/wizard/Interest.vue';
import Experience from '@/components/wizard/Experience.vue';
import EuExperience from '@/components/wizard/EuExperience.vue';
import Study from '@/components/wizard/Study.vue';
import PersonalData from '@/components/wizard/PersonalData.vue';
import TrainingDuration from '@/components/wizard/TrainingDuration.vue';
import OtherSkill from '@/components/wizard/OtherSkill.vue';
import Language from '@/components/wizard/Language.vue';
import Residence from '@/components/wizard/Residence.vue';
import GovOfficialType from '@/components/wizard/GovOfficialType.vue';
import OfficialEligibility from '@/components/wizard/OfficialEligibility.vue';
import CastEligibility from '@/components/wizard/CastEligibility.vue';
import TraineeshipRequired from '@/components/wizard/TraineeshipRequired.vue';
import SpecialNeeds from '@/components/wizard/SpecialNeeds.vue';
// Blocks : END
import ApplicationPage from './ApplicationPage.vue';

import ApplicationOverview from '../components/ApplicationOverview.vue';
import HelpersMixin from '../mixins';
export default defineComponent({
    name: 'WizardPage',
    components: {
        ConfirmPopup,
        TabView,
        TabPanel,
        Interest,
        Experience,
        EuExperience,
        Study,
        PersonalData,
        Residence,
        TrainingDuration,
        Language,
        OtherSkill,
        GovOfficialType,
        OfficialEligibility,
        CastEligibility,
        TraineeshipRequired,
        SpecialNeeds,
        Toast,
        Dialog,
        Skeleton,
        ApplicationPage,
        ApplicationOverview,
        Checkbox
    },
    computed: {
        ...mapGetters([
            'selectedLanguage',
            'currentSite',
            'isCORSite',
            'wizardStructure',
            'wizardData',
            'wizardErrors',
            'selectedLanguage',
            'applicationStatusIcon',
            'canApply',
            'isRegisteredApplication',
            'appLoading',
        ]),
    },
    methods: {
        ...mapActions([
            'loadAppData',
            'loadWizard',
            'loadApplicationData',
            'triggerSetStepsStatus',
            'submitApplication',
            'redirectToDashboard',
        ]),
        toggleCheckbox(data){
            this[data] = !this[data]
        },
        toggleApplicationOverview(){
            this.showApplicationOverview = !this.showApplicationOverview;
        },
        changeTab(index) {
            this.activeTab = index;
            this.triggerSetStepsStatus();
            const wizardSteps =
                document.getElementsByClassName('wizard-steps')[0];
            wizardSteps.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            this.onTabChange();
        },
        onTabChange() {
            setTimeout(() => {
                const tabElements = document.querySelectorAll('.p-tabview-panel');
                const activeTab = [...tabElements].filter(el => {
                    if (el.style.display !== 'none'){
                        return el;
                    }
                });
                if (activeTab.length) {
                    const availableInputs = activeTab[0].querySelectorAll('input')
                    availableInputs[0].focus();
                    // console.log(availableInputs[0])
                }
            })
            
        },
        stepIcon(step) {
            let stepIcon;
            switch (step.translationKey) {
                case 'lib_step_personal_data':
                    stepIcon = 'fas fa-user-shield';
                    break;
                case 'lib_step_edu_exp':
                    stepIcon = 'fas fa-user-graduate';
                    break;
                case 'lib_step_application':
                    stepIcon = 'fas fa-user-cog';
                    break;
                case 'lib_step_eligibility':
                    stepIcon = 'fas fa-money-check';
                    break;
                case 'lib_step_special_needs':
                    stepIcon = 'fas fa-universal-access';
                    break;
                default:
                    stepIcon = 'fas fa-check';
                    break;
            }
            return stepIcon;
        },
        submitWizard() {
            if (this.canApply) {
                // Send data to backend;
                this.submitApplication(this.wizardData).then(
                    () => {
                        this.showConfirmDialog = false;
                        this.$toast.add({
                            severity: 'success',
                            detail: 'Application successfull!',
                            life: 3000,
                        });
                        this.redirectToDashboard();
                    },
                    () => {
                        this.$toast.removeAllGroups();
                        this.$toast.add({
                            severity: 'error',
                            detail: 'Errors are present in your form!',
                            life: 3000,
                        });
                    }
                );
            }
        },
        toggleConfirmDialog(action) {
            // action can be true or false, depending if you want to show/hide the dialog;
            this.showConfirmDialog = action;

            if (!action){
                this.firstCheckbox = false;
                this.secondCheckbox = false;
            }
        },
        focusOnNearestBlockError() {
            if (
                this.wizardErrors &&
                Object.keys(this.wizardErrors).length !== 0 &&
                this.isRegisteredApplication
            ) {
                this.$toast.removeAllGroups();
                this.$toast.add({
                    severity: 'error',
                    detail: this.$t('mess_save_failed'),
                    life: 3000,
                });
                for (let stepIndex in this.wizardStructure.steps) {
                    if (this.wizardStructure.steps[stepIndex].hasError) {
                        this.activeTab = Number(stepIndex);
                        for (let errorKey in this.wizardErrors) {
                            this.wizardStructure.steps[stepIndex].blocks.map(
                                (block) => {
                                    if (block.name === errorKey.split('.')[0]) {
                                        const blockWithError =
                                            document.getElementById(block.name);
                                        setTimeout(() => {
                                            blockWithError.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start',
                                            });
                                        }, 1000);
                                    }
                                }
                            );
                        }
                        return;
                    }
                }
            }
        },
    },
    data() {
        return {
            loading: true,
            activeTab: 0,
            showConfirmDialog: false,
            applicationType: null,
            applicationId: null,
            showApplicationOverview: false,
            firstCheckbox: false,
            secondCheckbox: false,
        };
    },
    created() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('id')) {
            this.applicationId = urlParams.get('id');
        }
        if (urlParams.has('type')) {
            this.applicationType = urlParams.get('type');
        }
        this.loadAppData();
    },
    mounted() {
        this.loadWizard(this.applicationType).then(
            () => {},
            () => {
                this.$toast.add({
                    severity: 'error',
                    detail: this.$t('lib_application_error'), // "There was an error loading your application in its current status! You will be redirected to the Dashboard.",
                    life: 3000,
                });
                setTimeout(() => {
                    this.redirectToDashboard();
                }, 3000);
            }
        );
        this.loadApplicationData({
            id: this.applicationId,
            includeValidationErrors: true,
        }).then(
            () => {
                this.loading = false;
                this.triggerSetStepsStatus();
                this.onTabChange();
            },
            (err) => {
                console.error('LoadApplicationData error', err);
                this.$toast.add({
                    severity: 'error',
                    detail: this.$t('lib_application_error'), // "There was an error loading your application in its current status! You will be redirected to the Dashboard.",
                    life: 3000,
                });
                setTimeout(() => {
                    this.redirectToDashboard();
                }, 3000);
            }
        );
    },
    mixins: [HelpersMixin],
});
</script>
